
import React from 'react';
import { useParams } from 'react-router-dom';
import exact from 'prop-types-exact';
import ArtistSingle from '../../components/artists/containers/ArtistSingleContainer';
import { getSingleArtist } from '../../components/artists/actions/ArtistSingleActions';
import { fetchArtistsSlidesIfNeeded } from '../../components/artists/actions/ArtistsActions';

const ArtistaInterna = () => {
    const { slug } = useParams();

    return (
        <div className="pageWrapper">
            <ArtistSingle slug={slug} />
        </div>
    );
};

ArtistaInterna.fetchData = (store, match) => {
    // @TODO join those requests into one?
    const myPromises = [
        store.dispatch(getSingleArtist(match.params.slug)),
        store.dispatch(fetchArtistsSlidesIfNeeded()),
    ];

    return Promise.all(myPromises);
};

ArtistaInterna.propTyopes = exact({});

export default ArtistaInterna;
